import React, { useCallback, useRef, useEffect, useState } from 'react';
import { FiLogIn, FiMail, FiLock, FiUser } from 'react-icons/fi';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';
// import logo from '../../assets/logo-compressed.png';

import {  supportNumber, authTitle } from '../../config';
import { Container, Content,  AnimatedDiv2,ErrorContainer } from './styles';
import Input from '../../components/Forms/Input';
import Button from '../../components/Button';
import getValidationErrors from '../../utils/getValidationErrors';

import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';
import Whatsapp from '../../components/Whatsapp';
import { useLanguage } from '../../hooks/Language';
import Loader from '../../components/Loader';
import { FaWhatsapp } from 'react-icons/fa';


interface SignInData {
  email: string;
  password: string;
  name: string;
}

interface IParams{
  redirect ?: string;
}

const SignIn: React.FC<IParams> = ({redirect = '/' }) => {
  const history = useHistory();
  const [withPassword, setWithPassword] = useState(false);
  const { signIn } = useAuth();
  const { addToast } = useToast();
  const formRef = useRef<FormHandles>(null);
  const [loading, setLoading] = useState(false);
  const {translate} = useLanguage();
  const [errorMessage, setErrorMessage] = useState<Record<string,string>>({});
  const [manutencao, setManutencao] = useState(false);
  const handleSubmit = useCallback(
    async (data: SignInData) => {
      setLoading(true);
      try {
        formRef.current?.setErrors({});

        const shape = withPassword
          ? {
              email: Yup.string()
                .required(`${translate('E-mail')} ${translate('obrigatório')}`),               
              password: Yup.string().required(`${translate('Senha')} ${translate('obrigatória')}`),
            }
          : {
              email: Yup.string()
                .required(`${translate('E-mail')} ${translate('obrigatório')}`)
                
            };

        const schema = Yup.object().shape(shape);
        const { email : email_trim } = data;
        data.email = email_trim.trim();

        await schema.validate(data, { abortEarly: false });

        const { email, name, password } = data;
        
        await signIn({ email, password, name });
        
        window.location.href = '/dashboard';
        return;
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          setLoading(false);
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
          return;
        }
        setLoading(false);

        const { status} = err?.response;

        if(status >= 500){
        
          setErrorMessage ({title : 'Um momento...', description: 'A plataforma do Congresso está passando uma por indisponibilidade técnica, mas nossa equipe está trabalhando para voltarmos ao vivo o quanto antes. Pedimos gentilmente a sua compreensão, lembrando que todo o conteúdo seguirá gravado, sem prejuízo de entrega.'})
          setTimeout(() => {
            setErrorMessage({});
          },60000)
        
        }
        else{

          setErrorMessage ({title : 'Usuário não identificado', description: 'Verifique se há alguma divergência em seus dados.'})
          setTimeout(() => {
            setErrorMessage({});
          },5000)
         
        }


   
       
      }
    },
    [signIn, addToast, history],
  );

  return (<>
  {loading  && <Loader message="Autenticando seu acesso ..."/>}
    <Container>
      <Content>
        <AnimatedDiv2 style={{background: 'rgba(255,255,255,1)', borderRadius: '10px'}}>
        
          { manutencao ?         <div className="onlineMessage ">
           
           <h2 className="defaultMarked"><div/>{translate('Estamos em manutenção')}</h2>
           <p style={{color: '#333', textAlign: 'center',marginTop: '20px'}}>
             {translate(
               'Voltamos em breve!',
             )}
           </p><br/>
         </div> : <Form className="form" ref={formRef} onSubmit={handleSubmit} >
         <img src="/assets/logo.png" style={{width: '100%', margin: '20px 0px'}}/>
      
         
          <h2 style={{margin: '20px auto', marginTop: '0px',color: '#395caf'}} className="titleElement">{translate('INSIRA SEU E-MAIL PARA ACESSAR')}</h2>
     
                    <Input  name="email" placeholder={translate('E-mail')} />
                  { withPassword &&  <Input
                      
                      name="password"
                      type="password"
                      placeholder={translate('Senha')}
                    /> }

                    { errorMessage && errorMessage.title && <ErrorContainer>
                      <h2>{errorMessage.title}</h2>
                      <p dangerouslySetInnerHTML={{__html: errorMessage.description}}/>
                      </ErrorContainer>}
                    <Button style={{margin:'10px auto', textTransform:'uppercase'}} type="submit">{translate('ACESSAR')}</Button>
                    { withPassword &&    <> <p style={{marginTop: '30px', color: '#395caf'}}>Caso tenha dificuldade em logar, solicite uma nova senha.</p>
                  <aside style={{display:'flex', justifyContent: 'center', width: '100%'}}> <Link style={{ color: '#fff' }} to="/recuperar_senha"><Button>{translate('Esqueci minha senha')}</Button>
                    
                    </Link></aside> </>}

                    <Link style={{ color: '#fff' }} to="/inscricao"><h2 style={{color: '#395caf', fontSize: '14px'}}>{translate('CRIAR NOVA CONTA')}</h2>
                    
                    </Link>
<aside style={{display:'flex', alignItems:'center', justifyContent:'center', width:'100%'}}>
  
                    <Whatsapp number="5551981476007" message="Suporte técnico" text={`Olá, estou no ${authTitle}`}/> 
</aside>
             
          </Form>}
        </AnimatedDiv2>
      </Content>
    </Container></>
  );
};
export default SignIn;
